import { lazy } from "react";

const routes = [
  {
    path: "/organization",
    element: lazy(() => import("../../pages/Saas/Organization")),
  },
  {
    path: "/organization/create",
    element: lazy(
      () => import("../../pages/Saas/Organization/create-editOrganization"),
    ),
  },
  {
    path: "/organization/edit/:id",
    element: lazy(
      () => import("../../pages/Saas/Organization/create-editOrganization"),
    ),
  },
];

export default routes;
